module.exports = __webpack_public_path__ + "img/patio-art.769e6502.jpg";